import { Component } from '@angular/core';

@Component({
  selector: 'app-parentapp-footer',
  templateUrl: './parentapp-footer.component.html',
  styleUrls: ['./parentapp-footer.component.scss']
})
export class ParentappFooterComponent {

}
